import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./Style.module.css";

const CustomerCreditDetails = ({
  customerCreditDetails,
  isLoading,
  balanceLabel = "Cashless Balance:",
  showTopUpAction = true,
  onTopUpClick,
  hasOpenMembershipSale = false,
  openMembershipSale = null,
  onOpenMembershipSale,
  openMembershipSaleLabel = "Go to Open Sale",
}) => {
  const hasMembership = Array.isArray(customerCreditDetails) && customerCreditDetails.length > 0;
  const primaryMembership = hasMembership ? customerCreditDetails[0] : null;
  const primaryBalance = hasMembership
    ? (primaryMembership?.current_credit_balance ??
        primaryMembership?.credit_balance)
    : "0.00";
  const isTruthy = (val) => val === true || val === 1 || val === "1" || val === "true";
  const transactions =
    primaryMembership?.transactions ||
    primaryMembership?.data?.transactions ||
    primaryMembership?.membership_detail?.transactions ||
    [];
  const pendingPaymentTransaction = Array.isArray(transactions)
    ? transactions.find((item) => item?.is_payment_pending === true && item?.sale_id)
    : null;
  const inferredOpenMembershipSale =
    Boolean(pendingPaymentTransaction) ||
    Boolean(primaryMembership?.is_payment_pending === true && primaryMembership?.sale_id) ||
    Boolean(isTruthy(primaryMembership?.payment_pending) && primaryMembership?.pending_topup_sale_id);
  const shouldShowOpenMembershipSale = Boolean(
    hasOpenMembershipSale ||
    openMembershipSale ||
    inferredOpenMembershipSale
  );
  const openSalePayload =
    openMembershipSale ||
    pendingPaymentTransaction ||
    (primaryMembership?.is_payment_pending === true && primaryMembership?.sale_id ? primaryMembership : null) ||
    (isTruthy(primaryMembership?.payment_pending) && primaryMembership?.pending_topup_sale_id
      ? {
          ...primaryMembership,
          id: primaryMembership.pending_topup_sale_id,
          sale_id: primaryMembership.pending_topup_sale_id,
          type: "membership",
          status: "pending payment",
          payment_status: "pending payment",
        }
      : null) ||
    primaryMembership?.open_membership_sale ||
    primaryMembership?.membership_detail?.open_membership_sale ||
    null;

  if (isLoading) {
    return (
      <div className={styles.customerCreditDetails}>
        <div className={styles.row}>
          <div className={styles.cellLeft}>
            <Skeleton width={180} height={16} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.customerCreditDetails}>
      <div className={styles.row}>
        <div className={styles.cellLeft}>
          <p>
            <i>{hasMembership ? balanceLabel : "No Membership Exist"}</i>
            {hasMembership && (
              <span>
                ${primaryBalance}
              </span>
            )}
          </p>
        </div>
        {shouldShowOpenMembershipSale && (
          <div className={styles.cellRight}>
            <button
              type="button"
              className={styles.topUpButton}
              onClick={() => onOpenMembershipSale?.(openSalePayload)}
            >
              {openMembershipSaleLabel}
            </button>
          </div>
        )}
        {showTopUpAction && !shouldShowOpenMembershipSale && (
          <div className={styles.cellRight}>
            <button
              type="button"
              className={styles.topUpButton}
              onClick={() => onTopUpClick?.(hasMembership ? "topup" : "purchase")}
            >
              {hasMembership ? "Top-up" : "Purchase"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerCreditDetails;
